<template>
  <v-stepper
    class="d-flex flex-column"
    v-model="currentStep"
    :style="{ 'margin-bottom': '40px' }"
    elevation="2"
  >
    <v-stepper-header>
      <v-stepper-step
        :complete="currentStep > 1"
        step="1"
        color="#e36013"
        :rules="[() => validateStep1]"
        :editable="done"
      >
        Set Merchant
        <small v-if="!validateStep1">not valid</small>
      </v-stepper-step>

      <v-divider />

      <v-stepper-step step="2" color="#e36013" :rules="[() => validateStep2]">
        Promo Detail
        <small v-if="!validateStep2">not valid</small>
      </v-stepper-step>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  props: ['step', 'done', 'validateStep1', 'validateStep2'],
  methods: {},
  computed: {
    currentStep() {
      return this.step;
    },
  },
};
</script>
